import React, { useState, useEffect, useRef } from 'react'
import { formatCurrency } from '../../utils/api'

function EditablePriceCell({ value, onChange, className = '' }) {
  const [editing, setEditing] = useState(false)
  const [tempValue, setTempValue] = useState(value || 0)
  const inputRef = useRef(null)

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [editing])

  const handleDoubleClick = () => {
    setTempValue(value || 0)
    setEditing(true)
  }

  const handleBlur = () => {
    setEditing(false)
    const numValue = parseFloat(tempValue) || 0
    if (numValue !== value) {
      onChange(numValue)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleBlur()
    } else if (e.key === 'Escape') {
      setTempValue(value || 0)
      setEditing(false)
    }
  }

  const formatPrice = (price) => {
    if (price === 0 || price === null || price === undefined) return '—'
    if (price === 0.01) return '⚠ Review'
    return formatCurrency(price)
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        type="number"
        step="0.01"
        min="0"
        value={tempValue}
        onChange={(e) => setTempValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        className="cell-input price-input"
      />
    )
  }

  return (
    <span
      className={`editable-price ${className}`}
      onDoubleClick={handleDoubleClick}
    >
      {formatPrice(value)}
    </span>
  )
}

export default EditablePriceCell
